export default __webpack_public_path__ + "static/media/info.6ca85b53.svg";